import React, { useEffect, useRef } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch } from "react-redux";
import { cancelSystemAnnouncementApi } from "store/actions";
import { CancelValidation } from "views/systemAnnouncement/Validation";
import LoadingButton from "components/shared/LoadingButton";

export default function CancelSystemAnnouncementModal({
    show,
    handleClose,
    loading,
    cancelAnnouncement
}) {
    console.log('cancelAnnouncement:>>>>>>>>>>>>> ', cancelAnnouncement);
    const dispatch = useDispatch();
    
    const initialValues = {
        cancellationReason: "",
        cancellationMessage: "",
        isCancelMessageToUser: false
    };


    const handleSubmit = (values) => {
        const payload = {
            _id: cancelAnnouncement?._id,
            ...values,
        };

        console.log("payload:", payload);

        dispatch(
            cancelSystemAnnouncementApi({
                data: payload,
                callback: (err) => {
                    if (!err) handleClose();
                },
            }),
        );
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
        >
            <Modal.Header className="py-3 text-dark" closeButton>
                <Modal.Title className="fw-bold text-dark">Cancel System Announcement</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    validationSchema={CancelValidation}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, errors, touched }) => (
                        <Form className="container">
                            <Row>
                                <Col md={12} className="mb-3">
                                    <label className="form-label">
                                        Cancellation Reason <span className="text-danger">*</span>
                                    </label>

                                    <Field
                                        name="cancellationReason"
                                        type="text"
                                        placeholder="Enter cancellation reason ..."
                                        className={`form-control ${errors.cancellationReason && touched.cancellationReason ? "is-invalid" : ""
                                            }`}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            setFieldValue("cancellationReason", value);

                                        }}
                                    />

                                    <ErrorMessage
                                        name="cancellationReason"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Col>

                            </Row>

                            {cancelAnnouncement?.type === "Info" && cancelAnnouncement?.isMaintenance && (
                                <Row className="mb-3">
                                    <Col md={4}>
                                        <label className="form-label fw-bold">
                                            Cancel Message Send To User
                                        </label>
                                    </Col>

                                    <Col md={8}>
                                        <div className="d-flex gap-4">
                                            <label className="form-check">
                                                <input
                                                    type="radio"
                                                    name="isCancelMessageToUser"
                                                    className="form-check-input"
                                                    checked={values.isCancelMessageToUser === true}
                                                    onChange={() => setFieldValue("isCancelMessageToUser", true)}
                                                />
                                                <span className="ms-2">Yes</span>
                                            </label>

                                            <label className="form-check">
                                                <input
                                                    type="radio"
                                                    name="isCancelMessageToUser"
                                                    className="form-check-input"
                                                    checked={values.isCancelMessageToUser === false}
                                                    onChange={() => setFieldValue("isCancelMessageToUser", false)}
                                                />
                                                <span className="ms-2">No</span>
                                            </label>

                                        </div>
                                    </Col>

                                    {values.isCancelMessageToUser === true && (
                                        <Col md={12} className="mb-3">
                                            <label className="form-label">
                                                Cancellation Message <span className="text-danger">*</span>
                                            </label>

                                            <Field
                                                name="cancellationMessage"
                                                type="text"
                                                placeholder="Enter cancellation message..."
                                                className={`form-control ${errors.cancellationMessage && touched.cancellationMessage
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                            />

                                            <ErrorMessage
                                                name="cancellationMessage"
                                                component="div"
                                                className="invalid-feedback"
                                            />
                                        </Col>
                                    )}

                                </Row>
                            )}

                            <Row className="justify-content-end mt-4">
                                <Col md={3}>
                                    <LoadingButton
                                        type="submit"
                                        className="btn btn-primary btn-lg w-100"
                                        loading={loading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Col>
                            </Row>


                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}